import React from 'react'

export default function MediaCard() {
    return (
        <div className="media-card-box">
            <a className="media-card__item" target="_blank" href="https://www.linkedin.com/in/kevin-laird16/"><i class="fab fa-linkedin"></i></a>
            <a className="media-card__item" target="_blank" href="https://github.com/KevinLaird"><i class="fab fa-github-square"></i></a>
            <a className="media-card__item" target="_blank" href="https://www.instagram.com/kevinlaird.me/"><i class="fab fa-instagram-square"></i></a>
            <a className="media-card__item" target="_blank" href="https://twitter.com/kevinlaird_ux"><i class="fab fa-twitter-square"></i></a>
            <a className="media-card__item" target="_blank" href="../assets/profile/resume.pdf"><i class="fas fa-file-pdf"></i></a>
        </div>
    )
}